import React, { useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { notificationFilterById } from "../../../../../actions/Utilities/NotificationFilter";
import AddButton from "../../../../../components/AddButton";
import ConfirmBoxDelete from "../../../../../components/ConfirmBoxDelete";
import EditButton from "../../../../../components/EditButton";
import MaterialTableTS from "../../../../../components/tables/MaterialTableTS";
import { toast } from "../../../../../components/toastNotification";
import { permissionsSelector } from "../../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../../PermissionsConstants";
import TableFilters from "../../TableFilters";
import {
  addStateEmployeeTitle,
  editStateEmployeeTitle,
  rowForEditEmployeeTitle,
  selectedRowsEmpTitleToDelete,
} from "../atoms/atoms";
import EmployeeTitleForm from "../form/EmployeeTitleForm";
import useDeactivateEmpTitle from "../hooks/useDeactivateEmpTitle";
import useGetEmployeeTitle from "../hooks/useGetEmployeeTitle";
import { useHistory, useLocation } from "react-router-dom";
interface EmpTitleProps { }
export const EmployeeTitleTable: React.FC<EmpTitleProps> = () => {
  const userPermissions = useRecoilValue(permissionsSelector);
  const addPermission =
    PERMISSIONS.permission_utilities_employeetype_employeetitle_add;
  const editPermission =
    PERMISSIONS.permission_utilities_employeetype_employeetitle_edit;
  const deletePermission =
    PERMISSIONS.permission_utilities_employeetype_employeetitle_delete;

  const [employeeTitleList, setEmployeeTitleList] = useState([]);
  const [addState, setAddState] = useRecoilState(addStateEmployeeTitle);
  const [editState, setEditState] = useRecoilState(editStateEmployeeTitle);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsEmpTitleToDelete
  );
  const [rowsCount, setRowsCount] = useState(0);
  const setRowToEdit = useSetRecoilState(rowForEditEmployeeTitle);
  const BulkDeleteEmailDomain = useDeactivateEmpTitle();
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [empTitleFilteredData, setEmpTitleFilteredData] = useState([]);

  const tableRef = useRef<any>(null)
  
  const {
    data: employeeTitleData,
    isLoading: isFetching,
    isSuccess: employeeTitleSuccess,
  } = useGetEmployeeTitle();

  const alignCenter = "center" as
    | "center"
    | "inherit"
    | "justify"
    | "left"
    | "right"
    | undefined;

  useEffect(() => {
    if (employeeTitleSuccess && employeeTitleData) {
      if (employeeTitleData?.status === 200) {
        setEmployeeTitleList(
          employeeTitleData?.data.map((data) => ({ ...data }))
        );
      } else {
        toast.fire(
          "Server Error",
          "Cannot retrieve Employee Title Data",
          "error"
        );
      }
      setEmployeeTitleList([]);
    }
  }, [employeeTitleData, employeeTitleSuccess]);

  const handleAdd = () => {
    setAddState(true);
  };

  const handleEdit = (rowDetails) => {
    setRowToEdit({ ...rowDetails, isActive: rowDetails.isActive });
    setEditState(true);
  };

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${rowsCount > 1 ? "Employee Titles" : "Employee Title"
      }?`}</div>
  );

  useEffect(() => {
    setSelectedRows([]);
  }, []);

  const handleDelete = () => {
    const ids = selectedRows
      ? selectedRows.map((row) => row.employeeTitleId)
      : undefined;
    BulkDeleteEmailDomain(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
  };

  const handleCloseDeleteModal = () => {
    setSelectedRows([]);
    tableRef.current?.onAllSelected(false)
    setOpenModalDelete(false);
  };

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent;

  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }

  //For filtered data update
  const [empTitleId, setEmpTitleId] = useState("");
  useEffect(() => {
    if (empTitleId?.includes(".")) {
      let empTitleIds = empTitleId.split(".");
      const empTitleIdsArr = empTitleIds.map((id) => Number(id));
      const filteredData = employeeTitleData?.data?.filter((x) =>
        empTitleIdsArr.includes(x.employeeTitleId)
      );
      setEmpTitleFilteredData(filteredData);
    } else {
      const filteredData = employeeTitleData?.data?.filter(
        (x) => x.employeeTitleId === Number(empTitleId)
      );
      setEmpTitleFilteredData(filteredData);
    }
  }, [empTitleId, employeeTitleData]);

  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setEmpTitleFilteredData(result);
          setEmpTitleId(recordIdFromRecent.recordId);
        });
      } catch (error) { }
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, [history, recordIdFromRecent]);

  useEffect(() => {
    if (filterText) {
      setEmployeeTitleList(
        employeeTitleData?.data.filter((x) =>
          x.employeeTitleName
            .toLowerCase()
            .includes(filterText?.trim().toLowerCase())
        )
      );
    } else {
      setEmployeeTitleList(employeeTitleData?.data);
    }
  }, [filterText, employeeTitleData?.data]);

  const matColumns = [
    {
      title: "Employee Title Name",
      field: "employeeTitleName",
      customSort: (a, b) =>
        a.employeeTitleName && b.employeeTitleName
          ? a.employeeTitleName.trim().localeCompare(b.employeeTitleName.trim())
          : a.employeeTitleName
            ? 0
            : -1,
    },
    {
      title: "Is Mexico",
      field: "usedInMexico",
      render: (rowData) => rowData.usedInMexico === true ? "Yes" : "No"
    },
    {
      title: "Job Code",
      field: "jobCode",
      customSort: (a, b) =>
        a.jobCode && b.jobCode
          ? a.jobCode.trim().localeCompare(b.jobCode.trim())
          : a.jobCode
            ? 0
            : -1,
    },
    {
      title: "Job Long",
      field: "jobLong",
      customSort: (a, b) =>
        a.jobLong && b.jobLong
          ? a.jobLong.trim().localeCompare(b.jobLong.trim())
          : a.jobLong
            ? 0
            : -1,
    },
    {
      title: "Created By",
      field: "createdBy",
      customSort: (a, b) =>
        a.createdBy && b.createdBy
          ? a.createdBy.trim().localeCompare(b.createdBy.trim())
          : a.createdBy
            ? 0
            : -1,
    },
    {
      title: "Created Date",
      field: "createdDate",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowData) =>
        rowData?.createdDate ? (
          <div className="">
            <div>{new Date(rowData?.createdDate).toLocaleDateString()}</div>
          </div>
        ) : (
          ""
        ),
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      customSort: (a, b) =>
        a.modifiedBy && b.modifiedBy
          ? a.modifiedBy.trim().localeCompare(b.modifiedBy.trim())
          : a.modifiedBy
            ? 0
            : -1,
    },
    {
      title: "Modified Date",
      field: "modifiedDate",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowData) =>
        rowData?.modifiedDate ? (
          <div className="">
            <div>{new Date(rowData?.modifiedDate).toLocaleDateString()}</div>
          </div>
        ) : (
          ""
        ),
    },
    {
      title: "Status",
      field: "isActive",
      render: (rowData) => {
        return rowData?.isActive ? "Active" : "Inactive";
      },
    },
    {
      title: "Action/s",
      align: alignCenter,
      hidden: !userPermissions.includes(editPermission),
      render: (rowData) => {
        return (
          <div className="flex flex items-center place-content-center mr-5">
            <EditButton
              className={""}
              disabled={
                editState ||
                (selectedRows !== undefined && selectedRows.length > 0)
              }
              onClick={() => {
                handleEdit(rowData);
              }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="bg-white w-full">
      <div className="p-4">
        {addState || editState ? (
          <EmployeeTitleForm
            isAdd={addState}
            isEdit={editState}
            setIsAdd={setAddState}
            setIsEdit={setEditState}
          />
        ) : (
          <div>
            <div className="flex flex-row justify-between items-center mb-2">
              <TableFilters
                moduleDetails={"employeeTitleName"}
                textInputName={"EmployeeTitleName"}
                columnDetails={"Employee Title Name"}
                filterText={setFilterText}
                disabledButton={
                  editState ||
                  (selectedRows !== undefined && selectedRows.length > 0)
                }
              />

              <div>
                {userPermissions.includes(addPermission) ? (
                  <>
                    <AddButton
                      buttonText="New Employee Title"
                      onClick={() => handleAdd()}
                      disabled={
                        editState ||
                        (selectedRows !== undefined && selectedRows.length > 0)
                      }
                    />
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div>
              {userPermissions.includes(deletePermission) ? (
                <div className="text-secondary italic text-xs3 my-2">
                  <p className="font-bold italic inline-block mr-1">Note:</p>
                  <span>Tick the box to deactivate some data.</span>
                </div>
              ) : (
                <div className="mb-4"></div>
              )}
            </div>

            <div>           
                <MaterialTableTS
                data={
                  empTitleFilteredData?.length > 0
                  ? empTitleFilteredData
                  : employeeTitleList
                }
                showTitle={true}
                columns={matColumns}
                isLoading={isFetching}
                onSelectionChange={handleSelectedRowsChange}
                selectedRows={selectedRows}
                selection={
                  !editState &&
                  !addState &&
                  userPermissions.includes(deletePermission)
                }
                setConfirmModalOpen={setOpenModalDelete}
                tableRef={tableRef}
              />
              <ConfirmBoxDelete
                ModalTitle="Deactivate Employee Title"
                qConfirmation={deleteMessage}
                isOpen={openModalDelete}
                onClose={
                  handleCloseDeleteModal
                }
                onClickFunction={handleDelete}
                cancelButtonRef={undefined}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeTitleTable;




